import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  container: {
    cursor: 'pointer',
    flex: 1,
    padding: 16,
    margin: 0,
    width: '100%',
    minWidth: 280,
    height: 'auto',
    fontSize: 14,
    overflow: 'hidden',
    borderRadius: 14,
    shadowColor: 'rgba(0, 0, 0, 0.04)',
    shadowOffset: {
      width: 4,
      height: 8
    },
    shadowRadius: 4,
    backgroundPosition: '100%',
    backgroundSize: '8px 100%',
    backgroundRepeat: 'no-repeat'
  },
  title: {
    fontWeight: '500',
    fontSize: 24
  },
  textStatus: {
    marginTop: 4,
    fontSize: 14
  }
})
